import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import SessionContext from '../contexts/SessionContext';

export interface PartstraderLocation {
	id: string;
	name: string;
}

export interface CccLocation {
	id: string;
	name: string;
	address?: string;
	city?: string;
	state?: string;
	zip?: string;
}

export interface LocationMapping {
	partstraderId: string;
	cccId: string;
}

export interface ReconcileInput {
	partstraderLocations: PartstraderLocation[];
	cccLocations: CccLocation[];
}

export interface ReconcileResponse {
	mappings: LocationMapping[];
	unmatchedPt: string[];
	unmatchedCcc: string[];
}

export const useReconcileLocations = () => {
	const sessionContext = useContext(SessionContext);
	const reconcile = async (input: ReconcileInput) => {
		const { data } = await axios.post<ReconcileResponse>(
			`${API_URL}/onboarding/reconcile-locations`,
			input,
			{ headers: { Authorization: sessionContext?.sessionId ?? '' } }
		);
		return data;
	};

	return useMutation({
		mutationFn: reconcile,
	});
};
